module.exports = __webpack_public_path__ + "img/LUB00397.d35fafa2.png";